/**
 * FinanciacionPage component
 * @returns <FinanciacionPage />
 */
// Import necessary components and hooks
import Breadcrumbs from "../components/Breadcrumbs"
import BigPhotoAndDescription from "../components/BigPhotoAndDescription";
import Accordion from "../components/Accordion"
import Column from "../components/Column";

// Import necessary libraries and hooks
import { useLocation } from "react-router-dom";
import { useGetFinancingDataQuery } from "../redux/apiSlice";
import { AnimatePresence } from "framer-motion";
import Loader from "../components/Loader";

// FinanciacionPage component
const FinanciacionPage = () => {
    // Get the current location to use for Breadcrumbs
    const location = useLocation();

    // Define the BreadcrumbsProps to be passed to the Breadcrumbs component
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: location.pathname,
                label: location.pathname.slice(1)
            },
        ],
    }

    // Get financing data using useGetFinancingDataQuery custom hook
    const {
        data: financingData,
        isFetching,
        isLoading,
        isSuccess,
        isError
    } = useGetFinancingDataQuery();

    // console.log(financingData);

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}

            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <section className="financiacion" style={{ backgroundColor: "white" }}>
                        <div className="wrapper">
                            <div className="title-and-subtitle">
                                <h1 className="title">{financingData.title}</h1>

                                <p className="main-subtitle">{financingData.subtitle}</p>
                            </div>
                        </div>

                        {financingData.plans.map((plan, i) => {
                            return (
                                <div className="financiacion__plan" key={i}>
                                    <BigPhotoAndDescription {...plan} />

                                    <Column columns={3} boxes={plan.items[0].boxes} />

                                    <Accordion items={plan.items[0].accordion.items} />
                                </div>
                            )
                        })}
                    </section>
                </>
            )}

            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default FinanciacionPage